import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import Rating from 'react-rating';
import moment from 'moment';
import { handleConfirmCancel, handleError } from '@components/toast';
import { Star } from 'react-feather';
import { useMutation } from '@apollo/client';
import { DeleteRoad } from '../../../../../graphql/Mutation';
import Sidebar from './SideBar';

const renderMembership = (type) => {
  switch (type) {
    case 'FREE':
      return {
        name: 'Free'
      };
    case 'PREMIUM':
      return {
        name: 'Premium'
      };
    case 'FREEMIUM': {
      return {
        name: 'Freemium'
      };
    }
    default: {
      return { name: '' };
    }
  }
};

export const RoadInfo = ({ data }) => {
  const navigate = useNavigate();
  const [openSideBar, setOpenSideBar] = useState(false);
  const [deleteRoadById] = useMutation(DeleteRoad);
 
  const handleDelete = async (roadId) => {
    handleConfirmCancel('delete', true, async () => {
      try {
        await deleteRoadById({ variables: { roadId } });
        navigate('/roads/list');
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const toggleSidebar = () => {
    setOpenSideBar(!openSideBar);
  };

  const getGender = ({gender}) => {
    
     switch (gender) {
        case 'EMPTY':
          return 'Todos';
        case 'MALE':
          return 'Masculino';
        case 'FEMALE':
          return 'Femenino';
        case 'OTHER':
          return 'Otros';    
     }
  };

  return (
    <>
      <Card body>
        <Col md="12" className="d-flex gap-1 justify-content-between">
          <Col md={5}>
            <Col md="12" className="d-flex">
              <Col
                md="3"
                style={{
                  width: '106px',
                  height: '96px',
                  backgroundImage: `url(${data.cover})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center',
                  backgroundSize: 'cover'
                }}
              />

              <Col
                md={9}
                className="d-flex flex-column align-items-start justify-content-end gap-1"
                style={{ marginLeft: '5px' }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: 14
                  }}
                >
                  {data.name}
                </div>

                <div className="d-flex align-items-center gap-md-0 gap-lg-1">
                  <Button
                    color="primary"
                    onClick={() => {
                      navigate(`/roads/edit/${data._id}`);
                    }}
                  >
                    Editar
                  </Button>
                  <Button
                    color="danger"
                    outline
                    onClick={() => handleDelete(data._id)}
                  >
                    Eliminar
                  </Button>
                </div>
              </Col>
            </Col>

            <Row className="mt-2">
              <Col>
                <div className="fw-bold">Calificación:</div>
                <Rating
                  direction="ltr"
                  initialRating={data.rate}
                  readonly
                  emptySymbol={
                    <Star
                      size={18}
                      className="me-1"
                      fill="#B9B9C3"
                      stroke="#B9B9C3"
                    />
                  }
                  fullSymbol={
                    <Star
                      size={18}
                      className="me-1"
                      color="#FFCB3C"
                      fill="#FFCB3C"
                    />
                  }
                />
              </Col>
            </Row>
          </Col>

          <Col md={3} className="d-flex gap-1">
            <Col
              md="6"
              className="d-flex flex-column gap-1"
              style={{
                color: '#6D6B7B',
                fontSize: 12,
                fontWeight: 600
              }}
            >
              <span>Tipo de plan</span>
              <span>Episodios</span>
              <span>Status</span>
              <span>Creado</span>
            </Col>
            <Col
              md="6"
              className="d-flex flex-column gap-1"
              style={{ fontSize: '12px' }}
            >
              <span>{renderMembership(data.membership).name}</span>
              <span>
                {data.episodes.length}{' '}
                <Button
                  style={{
                    fontSize: 10,
                    padding: 5,
                    cursor: 'pointer'
                  }}
                  color="primary"
                  onClick={() => {
                    toggleSidebar();
                  }}
                >
                  Ver episodios
                </Button>
              </span>
              <span>{data.status ? 'Activo' : 'Inactivado'}</span>
              <span style={{ fontSize: '11' }}>
                {moment(data.createdAt).format('L')}
              </span>
            </Col>
          </Col>

          <Col md={3} className="d-flex gap-1">
            <Col
              md="6"
              className="d-flex flex-column gap-1"
              style={{
                color: '#6D6B7B',
                fontSize: 12,
                fontWeight: 600
              }}
            >
              <span>Iniciados</span>
              <span>Finalizados</span>
              <span>Completados</span>
              <span>Género</span>
            </Col>
            <Col
              md="6"
              className="d-flex flex-column gap-1"
              style={{
                color: '#6D6B7B',
                fontSize: 12
              }}
            >
              <span>{data.started}</span>
              <span>{data.finished}</span>
              <span>
                {data.started > 0
                  ? `${(parseFloat(data.finished * 100) / data.started).toFixed(2)}%`
                  : '0%'}
              </span>
              <span>{getGender(data)}</span>
            </Col>
          </Col>
        </Col>
      </Card>
      <Sidebar
        open={openSideBar}
        toggleSidebar={toggleSidebar}
        data={data.episodes}
      />
    </>
  );
};
